import * as types from '../actions/actionTypes.js';
import initialState from "./initialState.js";


export function mealReducer(
    state = initialState.meal, action
) {
    switch(action.type) {
        case types.ADD_MEAL_SUCCESS:
            return action.meal;
        case types.EDIT_MEAL_SUCCESS:
            return action.meal;
        case types.FETCH_MEAL_SUCCESS:
            return action.meal;
        case types.REMOVE_MEAL_SUCCESS:
            return action.response;
        default:
            return state;
    }
}
